// extracted by mini-css-extract-plugin
export default {"early_icon":"early-alert_early_icon__AkHOk"};